<div class="adminActions_container">
    <div class="adminActions_messagesPart">
        <span class="adminActions_errorMessage">{{adminActionMessage}}</span>
    </div>
    <div *ngIf="presentReallocateTokensPart" class="adminActions_actionContainer">
        <span class="adminActions_sectionHeader">{{"adminActions.reallocateTokensHeader" | translate}}</span>
        <span class="adminActions_errorMessage" *ngIf="reallocateTokenByAmountFailed">{{reallocateTokensErrorMessage}}</span>
        <div class="adminActions_reallocateTokensByAmountContainer">
            <mat-form-field class="adminActions_reallocateTokensResllerMail" appearance="fill">
                <mat-label>{{'adminActions.resellerMailLabel' | translate}}</mat-label>
                <input matInput class="adminActions_reallocateTokensResllerMailInput" [(ngModel)]="reallocateAccessTokens_resellerMail" required>
             </mat-form-field>
            <mat-form-field>
                <mat-label>{{"adminActions.reallocateTokensAmount" | translate}}</mat-label>
                <input matInput [(ngModel)]="tokensAmount" type="number" placeholder="0">
            </mat-form-field>
            <mat-form-field appearance="fill">            
                <mat-label>{{"adminActions.reallocateTokensAccountType" | translate}}</mat-label>
                <mat-select [(ngModel)]="selectedAccountTypeForTokenAllocation">
                    <mat-option [value]="accountTypeEnuInstance.CLARO_DISCOVERY">{{'general.accountType_Discovery' | translate}}</mat-option>
                    <mat-option [value]="accountTypeEnuInstance.THRIVE">{{'general.accountType_Thrive' | translate}}</mat-option>
                    <mat-option [value]="accountTypeEnuInstance.COLLAB">{{'general.accountType_Collab' | translate}}</mat-option>
                    <mat-option [value]="accountTypeEnuInstance.EXCEL">{{'general.accountType_Excel' | translate}}</mat-option>
                    <mat-option [value]="accountTypeEnuInstance.CAREER_INDEPENDENT">{{'general.accountType_CareerIndependent' | translate}}</mat-option>
                    <mat-option [value]="accountTypeEnuInstance.CAREER_INDEPENDENT_US">{{'general.accountType_CareerIndependent_US' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill">            
                <mat-label>{{"adminActions.reallocateTokensCareerProcessType" | translate}}</mat-label>
                <mat-select [(ngModel)]="selectedCareerProcessTypeForTokenAllocation">
                    <mat-option [value]="careerProcessTypeEnumInstance.NONE">{{'general.careerProcessType_None' | translate}}</mat-option>
                    <mat-option [value]="careerProcessTypeEnumInstance.INDEVIDUAL_CONSULTANT_LEAD">{{'general.careerProcessType_Individual_Consultant_Lead' | translate}}</mat-option>
                    <mat-option [value]="careerProcessTypeEnumInstance.INTERNAL_ORGANIZATION_LEAD">{{'general.careerProcessType_Internal_Organization_Lead' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>            
        </div>
        <button mat-raised-button *ngIf="!isWaitingForReallocation" class="adminActions_generalButton" (click)="reallocateTokensByAmount()">{{"adminActions.reallocateTokensButton" | translate}}</button>
        <mat-spinner [diameter]="40" *ngIf="isWaitingForReallocation"></mat-spinner>
        <div *ngIf="res_reallocatedTokensList && res_reallocatedTokensList.length > 0">
            <span class="adminActions_reallocatedTokensHeader">{{"adminActions.reallocatedAccessTokensHeader" | translate}} {{reallocateAccessTokens_resellerMail}}</span>
            <mat-list-item *ngFor="let reallocatedToken of res_reallocatedTokensList" role="listitem">{{reallocatedToken}}</mat-list-item>
        </div>
    </div>
    <mat-divider class="adminActions_divider"></mat-divider>
    <div class="adminActions_userAdminContainer">
        <span class="adminActions_sectionHeader">{{"adminActions.userAdminChangeParentHeader" | translate}}</span>
        <div class="adminActions_inputPart">
            <div class="adminActions_horizontalFormFieldsContainer">
                <mat-form-field class="adminActions_reallocateTokensResllerMail" appearance="fill">
                    <mat-label>{{'adminActions.parentMailLabel' | translate}}</mat-label>
                    <input matInput class="adminActions_reallocateTokensResllerMailInput" [(ngModel)]="changeParent_parentMail" required>
                 </mat-form-field>
                 <mat-form-field class="resellerActions_usersReportField" appearance="outline">
                    <mat-label>{{'adminActions.usersReportListLabel' | translate}}</mat-label>
                    <textarea matInput class="resellerActions_usersReportInput" [(ngModel)]="changeParent_SubordinatesList"></textarea>
                </mat-form-field>   
            </div>
            <mat-spinner [diameter]="40" *ngIf="isWaitingForParentChange"></mat-spinner>
            <div *ngIf="userMgmt_changeParentFailed && changeParent_missingUsers.length > 0" class="adminActions_resultPart">
                <span class="adminActions_reallocatedTokensHeader">{{"adminActions.missingUsers" | translate}}</span>
                <mat-list-item *ngFor="let missingUser of changeParent_missingUsers" role="listitem">{{missingUser}}</mat-list-item>
            </div>        
        </div>
        <button mat-raised-button *ngIf="!isWaitingForParentChange" class="adminActions_generalButton" (click)="userManagement_changeParent()">{{"adminActions.reallocateTokensButton" | translate}}</button>
    </div>
    <mat-divider class="adminActions_divider"></mat-divider>
    <div class="adminActions_userAdminContainer">
        <span class="adminActions_sectionHeader">{{"adminActions.userAdminChangeOrgHeader" | translate}}</span>
        <div class="adminActions_inputPart">
            <div class="adminActions_horizontalFormFieldsContainer">
                <mat-form-field class="adminActions_reallocateTokensResllerMail" appearance="fill">
                    <mat-label>{{'adminActions.orgIdLabel' | translate}}</mat-label>
                    <input matInput class="adminActions_reallocateTokensResllerMailInput" [(ngModel)]="changeOrg_orgId" required>
                 </mat-form-field>
                 <mat-form-field class="resellerActions_usersReportField" appearance="outline">
                    <mat-label>{{'adminActions.usersReportListLabel' | translate}}</mat-label>
                    <textarea matInput class="resellerActions_usersReportInput" [(ngModel)]="changeOrg_usersList"></textarea>
                </mat-form-field>   
            </div>
            <mat-spinner [diameter]="40" *ngIf="isWaitingForOrgChange"></mat-spinner>
            <div *ngIf="userMgmt_changeOrgFailed && changeOrg_missingUsers.length > 0" class="adminActions_resultPart">
                <span class="adminActions_reallocatedTokensHeader">{{"adminActions.missingUsers" | translate}}</span>
                <mat-list-item *ngFor="let missingUser of changeOrg_missingUsers" role="listitem">{{missingUser}}</mat-list-item>
            </div>    
        </div>
        <button mat-raised-button *ngIf="!isWaitingForOrgChange" class="adminActions_generalButton" (click)="userManagement_changeOrg()">{{"adminActions.updateOrgButton" | translate}}</button>
    </div>
    <mat-divider class="adminActions_divider"></mat-divider>
    <div class="adminActions_userAdminContainer">
        <span class="adminActions_sectionHeader">{{"adminActions.userAdminSetOrExpirationHeader" | translate}}</span>
        <div class="adminActions_inputPart">
            <mat-form-field class="adminActions_reallocateTokensResllerMail" appearance="fill">
                <mat-label>{{'adminActions.orgIdLabel' | translate}}</mat-label>
                <input matInput class="adminActions_reallocateTokensResllerMailInput" [(ngModel)]="setOrgExpiration_orgId" required>
             </mat-form-field>
             <mat-form-field class="resellerActions_usersReportField" appearance="outline">
                <mat-label>Input disabled</mat-label>
                <input matInput [matDatepicker]="picker" disabled [(ngModel)]="setOrgExpiration_expirationDate">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker disabled="false"></mat-datepicker>
             </mat-form-field>   
        </div>
        <button mat-raised-button class="adminActions_generalButton" (click)="orgManagement_setExpirationDate()">{{"adminActions.setExpirationDateButton" | translate}}</button>
    </div>
    <mat-divider class="adminActions_divider"></mat-divider>
    <div class="adminActions_userAdminContainer">        
        <span class="adminActions_sectionHeader">{{"adminActions.userAdminGetOrgsListHeader" | translate}}</span>
        <div class="adminActions_inputPart">
            <div class="adminActions_horizontalFormFieldsContainer">
                <mat-form-field class="adminActions_reallocateTokensResllerMail" appearance="fill">
                    <mat-label>{{'adminActions.mailLabel' | translate}}</mat-label>
                    <input matInput class="adminActions_reallocateTokensResllerMailInput" [(ngModel)]="getResellerOrgs_resellerMail" required>
                 </mat-form-field>
            </div>
            <mat-spinner [diameter]="40" *ngIf="isWaitingForResellerOrgsList"></mat-spinner>
        </div>
        <div *ngIf="getOrgs_getOrgsDone" class="adminActions_resultPart">
            <span class="adminActions_reallocatedTokensHeader">{{"adminActions.getResellerOrgs_foundOrgs" | translate}}</span>
            <mat-list-item *ngFor="let currOrg of getOrgs_resellerOrgsList" role="listitem">
                <div class="getOrgs_resultsListItem">
                    <span>{{currOrg.name}}</span>
                    <span>{{currOrg.id}}</span>
                </div></mat-list-item>
            <span class="adminActions_errorMessage" *ngIf="getOrgs_resellerOrgsList.length == 0">{{"adminActions.getResellerOrgs_noOrgs" | translate}}</span>
        </div>           
        <button mat-raised-button *ngIf="!isWaitingForResellerOrgsList" class="adminActions_generalButton" (click)="userManagement_getResellerOrgs()">{{"adminActions.getResellerOrgsButton" | translate}}</button>
    </div>
    <mat-divider class="adminActions_divider"></mat-divider>
    <div class="adminActions_userAdminContainer">
        <span class="adminActions_sectionHeader">{{"adminActions.userAdminChangeUserToResellerHeader" | translate}}</span>
        <div class="adminActions_inputPart">
            <!-- when waiting for action to complete have a spinner here - shows the user that something is happening, 
                maybe also a textElment if err occoured could be useful -->
            <div class="adminActions_horizontalFormFieldsContainer">
                <mat-form-field class="adminActions_reallocateTokensResllerMail" appearance="fill">
                    <mat-label>{{'adminActions.mailLabel' | translate}}</mat-label>
                    <input matInput class="adminActions_reallocateTokensResllerMailInput" [(ngModel)]="updateToReseller_resellerMail" required>
                 </mat-form-field>
            </div>
            <!-- click logs for now  -->
            <div class="adminActions_bottomBuffer"></div>
        </div>
        <button mat-raised-button class="adminActions_generalButton" (click)="userManagement_updateUserToReseller()" >{{"adminActions.userAdminChangeUserToResellerBtn" | translate}}</button>
    </div>         
    <mat-divider class="adminActions_divider"></mat-divider>
    <div class="adminActions_userAdminContainer">
        <span class="adminActions_sectionHeader">{{"adminActions.orgDataUpdateMonitorHeader" | translate}}</span>
        <div class="adminActions_inputPart">
            <mat-form-field class="adminActions_reallocateTokensResllerMail" appearance="fill">
                <mat-label>{{'adminActions.orgIdLabel' | translate}}</mat-label>
                <input matInput class="adminActions_reallocateTokensResllerMailInput"
                       [(ngModel)]="getLastOrgDataUpdateReport_orgId"
                       (ngModelChange)="orgDataUpdatePreview = undefined; orgDataUpdateRuns = []; orgDataUpdateSelectedRun = undefined; orgDataUpdateComparison = undefined"
                       required>
             </mat-form-field>
            <button mat-raised-button class="adminActions_generalButton"
                    [disabled]="!getLastOrgDataUpdateReport_orgId || isWaitingForOrgDataUpdate"
                    (click)="previewOrgDataUpdate()">{{"adminActions.orgDataUpdatePreviewBtn" | translate}}</button>
            <button mat-raised-button class="adminActions_generalButton"
                    [disabled]="!getLastOrgDataUpdateReport_orgId"
                    (click)="loadOrgDataUpdateRuns()">{{"adminActions.orgDataUpdateHistoryBtn" | translate}}</button>
            <button mat-raised-button class="adminActions_generalButton"
                    [disabled]="!getLastOrgDataUpdateReport_orgId"
                    (click)="getLastOrgDataUpdateReport()">{{"adminActions.userAdminGetLastOrgDataUpdateReportBtn" | translate}}</button>
        </div>

        <mat-spinner [diameter]="40" *ngIf="isWaitingForOrgDataUpdate"></mat-spinner>
        <div class="resetPassword_notification resetPassword_notification--success" *ngIf="orgDataUpdateSuccessMessage">
            <mat-icon class="resetPassword_notification-icon">check_circle</mat-icon>
            <span class="resetPassword_notification-text">{{orgDataUpdateSuccessMessage}}</span>
        </div>
        <div class="resetPassword_notification resetPassword_notification--error" *ngIf="orgDataUpdateErrorMessage">
            <mat-icon class="resetPassword_notification-icon">error</mat-icon>
            <span class="resetPassword_notification-text">{{orgDataUpdateErrorMessage}}</span>
        </div>

        <div class="orgDataUpdate_summary" *ngIf="orgDataUpdatePreview as preview">
            <span><strong>{{"adminActions.orgDataUpdateRun" | translate}}:</strong> {{preview.runId}}</span>
            <span><strong>{{"adminActions.orgDataUpdateStatus" | translate}}:</strong> {{preview.status}}</span>
            <span>{{"adminActions.orgDataUpdateReceived" | translate}}: {{preview.summary.totalUsersReceived}}</span>
            <span>{{"adminActions.orgDataUpdateUpdated" | translate}}: {{preview.summary.totalUpdatedUsers}}</span>
            <span>{{"adminActions.orgDataUpdateDeactivated" | translate}}: {{preview.summary.totalDeactivatedUsers}}</span>
            <span>{{"adminActions.orgDataUpdateNewUsers" | translate}}: {{preview.newUsers?.length || 0}}</span>
            <span>{{"adminActions.orgDataUpdateVerification" | translate}}: {{preview.summary.verificationPassed}} / {{preview.summary.verificationFailed}}</span>
            <button mat-raised-button class="adminActions_generalButton"
                    *ngIf="preview.status === 'preview'"
                    [disabled]="isWaitingForOrgDataUpdate"
                    (click)="applyOrgDataUpdate()">{{"adminActions.orgDataUpdateApplyBtn" | translate}}</button>
            <button mat-raised-button class="adminActions_generalButton"
                    (click)="downloadOrgDataUpdateRun(preview)">{{"adminActions.orgDataUpdateDownloadBtn" | translate}}</button>
        </div>

        <div class="orgDataUpdate_history" *ngIf="orgDataUpdateRuns.length > 0">
            <span class="adminActions_sectionHeader">{{"adminActions.orgDataUpdateHistoryHeader" | translate}}</span>
            <div class="orgDataUpdate_runRow" *ngFor="let run of orgDataUpdateRuns">
                <span>{{run.createdAt}} · {{run.status}} · {{run.runId}}</span>
                <button mat-button (click)="viewOrgDataUpdateRun(run.runId)">{{"adminActions.orgDataUpdateViewBtn" | translate}}</button>
            </div>

            <div class="adminActions_horizontalFormFieldsContainer" *ngIf="orgDataUpdateRuns.length > 1">
                <mat-form-field appearance="fill">
                    <mat-label>{{"adminActions.orgDataUpdateCompareFrom" | translate}}</mat-label>
                    <mat-select [(ngModel)]="orgDataUpdateCompareFromRunId">
                        <mat-option *ngFor="let run of orgDataUpdateRuns" [value]="run.runId">{{run.createdAt}} · {{run.status}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{"adminActions.orgDataUpdateCompareTo" | translate}}</mat-label>
                    <mat-select [(ngModel)]="orgDataUpdateCompareToRunId">
                        <mat-option *ngFor="let run of orgDataUpdateRuns" [value]="run.runId">{{run.createdAt}} · {{run.status}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <button mat-raised-button class="adminActions_generalButton"
                        [disabled]="!orgDataUpdateCompareFromRunId || !orgDataUpdateCompareToRunId || orgDataUpdateCompareFromRunId === orgDataUpdateCompareToRunId"
                        (click)="compareOrgDataUpdateRuns()">{{"adminActions.orgDataUpdateCompareBtn" | translate}}</button>
            </div>
        </div>

        <div class="orgDataUpdate_details" *ngIf="orgDataUpdateSelectedRun as selectedRun">
            <span class="adminActions_sectionHeader">{{"adminActions.orgDataUpdateDetailsHeader" | translate}}</span>
            <span>{{selectedRun.runId}} · {{selectedRun.status}}</span>
            <div class="orgDataUpdate_change" *ngFor="let change of selectedRun.changes">
                <strong>{{change.type}} · {{change.email}}</strong>
                <span>{{"adminActions.orgDataUpdateVerification" | translate}}: {{change.verification.status}}</span>
                <pre *ngIf="change.fields">{{change.fields | json}}</pre>
            </div>
            <button mat-raised-button class="adminActions_generalButton"
                    (click)="downloadOrgDataUpdateRun(selectedRun)">{{"adminActions.orgDataUpdateDownloadBtn" | translate}}</button>
        </div>

        <div class="orgDataUpdate_details" *ngIf="orgDataUpdateComparison as comparison">
            <span class="adminActions_sectionHeader">{{"adminActions.orgDataUpdateComparisonHeader" | translate}}</span>
            <span>{{"adminActions.orgDataUpdateNewChanges" | translate}}: {{comparison.newChanges.length}}</span>
            <span>{{"adminActions.orgDataUpdateResolvedChanges" | translate}}: {{comparison.resolvedChanges.length}}</span>
            <span>{{"adminActions.orgDataUpdatePersistentChanges" | translate}}: {{comparison.persistentChanges.length}}</span>
            <pre>{{comparison.summaryDelta | json}}</pre>
        </div>
    </div>
    <mat-divider class="adminActions_divider"></mat-divider>
    <div class="adminActions_userAdminContainer">
        <span class="adminActions_sectionHeader">{{"adminActions.userAdminResetPasswordHeader" | translate}}</span>
        <div class="adminActions_inputPart">
            <div class="adminActions_horizontalFormFieldsContainer">
                <mat-form-field class="adminActions_resetPasswordFormField" appearance="fill">
                    <mat-label>{{"adminActions.userAdminResetPasswordEmailLabel" | translate}}</mat-label>
                    <input matInput type="email" [(ngModel)]="resetPassword_userMail" (ngModelChange)="resetPassword_errorMessage = ''; resetPassword_successMessage = ''" required>
                </mat-form-field>
                <mat-form-field class="adminActions_resetPasswordFormField" appearance="fill">
                    <mat-label>{{"adminActions.userAdminResetPasswordNewPasswordLabel" | translate}}</mat-label>
                    <input matInput [type]="resetPassword_showPassword ? 'text' : 'password'" [(ngModel)]="resetPassword_newPassword" required>
                    <button mat-icon-button matSuffix type="button" (click)="resetPassword_showPassword = !resetPassword_showPassword">
                        <mat-icon>{{resetPassword_showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <mat-spinner [diameter]="40" *ngIf="isWaitingForPasswordReset"></mat-spinner>
            <div class="resetPassword_notification resetPassword_notification--success" *ngIf="resetPassword_successMessage">
                <mat-icon class="resetPassword_notification-icon">check_circle</mat-icon>
                <span class="resetPassword_notification-text">{{resetPassword_successMessage}}</span>
            </div>
            <div class="resetPassword_notification resetPassword_notification--error" *ngIf="resetPassword_errorMessage">
                <mat-icon class="resetPassword_notification-icon">error</mat-icon>
                <span class="resetPassword_notification-text">{{resetPassword_errorMessage}}</span>
            </div>
        </div>
        <button mat-raised-button
                class="adminActions_generalButton"
                [disabled]="!resetPassword_userMail || !resetPassword_newPassword"
                *ngIf="!isWaitingForPasswordReset"
                (click)="userManagement_resetPassword()">{{"adminActions.userAdminResetPasswordBtn" | translate}}</button>
    </div>
</div>
